import {
  Component,
  Input,
  forwardRef,
  Injector,
  AfterViewInit
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
  UntypedFormControl
} from '@angular/forms';
import { SelectOption } from 'src/app/catalogs/catalogs.model';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements ControlValueAccessor, AfterViewInit {
  @Input() label: string;
  @Input() caption: string;
  @Input() placeholder: string;
  @Input() options: SelectOption[];
  @Input() _internalValue = '';
  @Input() showLabel = true;
  @Input() multiple = false;
  @Input() error: string;

  optionsAsValue: any[];
  touched = false;

  control: UntypedFormControl;

  onChange = (_: any) => {};
  onTouched = (_: any) => {};

  get internalValue() {
    return this._internalValue;
  }

  set internalValue(val: any) {
    if (val === undefined || val === null || val === '') {
      this._internalValue = '';
      this.onChange(undefined); // Value is rubbish, so don't send back to model propper
      return;
    }

    this._internalValue = val;
    this.onChange(this._internalValue); // Value is good!
  }

  constructor(private injector: Injector) {}

  ngAfterViewInit(): void {
    const ngControl: NgControl = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as UntypedFormControl;
    }
  }

  //////////////////////////////////
  // ControlValueAccessor interface
  //////////////////////////////////

  writeValue(value: any) {
    if (value === undefined || value === null) {
      this.internalValue = '';
      return;
    }

    this.internalValue = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    const self = this;
    this.onTouched = (arg: any) => {
      self.touched = true;
      fn(arg);
    };
  }
}
